/* eslint-disable no-unused-vars */
import ReactGA from "react-ga4";
import platform from "platform";
import { API_CONFIG } from "../config/api.config";

export const ANALYTICS_EVENT_TYPES = {
  PAGE_LOAD: "PAGE_LOAD",
  HEARTBEAT: "HEARTBEAT",
  BUTTON_CLICK: "BUTTON_CLICK",
  PAGE_READY: "PAGE_READY",
};

const mod = () => {
  const trackingID = API_CONFIG.GA_TRACKING_ID;
  let lastInteractionTime = Date.now();
  const getPlatform = () => {
    const label = `${platform.os.family}_${platform.os.version}_${platform.product}_${platform.name}`;
    return label;
  };

  const initializeAnalytics = (isRemoteAnalytics) => {
    if (!window.location.href.includes("localhost")) {
      ReactGA.initialize([
        {
          trackingId: trackingID,
          gaOptions: {
            siteSpeedSampleRate: 100,
            cookieFlags: "max-age=7200;secure;samesite=none",
          },
        },
      ]);
      ReactGA.send({
        hitType: "pageview",
        page: window.location.pathname + window.location.search,
      });
      lastInteractionTime = Date.now();
    } else {
      console.log("gainit");
      window[`ga-disable-${trackingID}`] = true;
    }
  };

  const sendAnalyticsEvent = (eventType, data = {}, options = {}) => {
    ReactGA.event({
      category: eventType,
      action: data.action,
      label: getPlatform(),
      nonInteraction: options.nonInteraction || true,
    });
    if (options.nonInteraction === true) lastInteractionTime = Date.now();
  };

  return {
    sendAnalyticsEvent,
    initializeAnalytics,
    getLastInteractionTime: () => lastInteractionTime,
  };
};

const GATracker = mod();
export default GATracker;
